import { applyAction } from './reducer';
import { createGame } from './state';
import type { Action, GameConfig, GameState } from './types';

/** Reconstrói a partida a partir da configuração (com seed) e da lista de ações. */
export function replay(config: GameConfig, actions: readonly Action[]): GameState {
  let s = createGame(config);
  for (const a of actions) s = applyAction(s, a);
  return s;
}

/**
 * Pode desfazer a última ação? Só se ela não usou o RNG (nenhum dado rolado,
 * nenhuma carta sorteada) e se foi feita por `player`.
 */
export function canUndo(state: GameState, player: number): boolean {
  return !!state.lastAction && !state.lastAction.random && state.lastAction.player === player && state.phase !== 'over';
}

/** Desfaz a última ação refazendo a partida sem ela. */
export function undo(config: GameConfig, actions: readonly Action[]): { state: GameState; actions: Action[] } {
  const kept = actions.slice(0, -1);
  return { state: replay(config, kept), actions: kept };
}
